import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import "./operatorpage.css";

import countryList from "./allthecountrydata.json";

const MobileInput = ({ iso3Code, setMobileNO, MobileNo }) => {
  // Get ISO2 from your data
  const countryData = countryList.find((c) => c?.iso_code === iso3Code?.toUpperCase());
  const iso2Code = countryData ? countryData?.flag_icon.toLowerCase() : "ae";


  const handelmobilenumber = (phoneValue, data) => {

    setMobileNO({ dialCode: data.dialCode, phoneValue: phoneValue });
  };
  return (
    <PhoneInput
      country={iso2Code}
      value={MobileNo?.phoneValue}
      onChange={handelmobilenumber}
      disableDropdown={true}
      enableSearch={false}
      placeholder="Enter mobile number"
      inputStyle={{
        width: "100%",
        paddingLeft: "65px", // enough space for dial code
      }}
      buttonStyle={{
        pointerEvents: "none", // prevent flag click
      }}
      containerClass="custom-phone-input"
    />
  );
};

export default MobileInput;
